import { JOB_TEMPLETE_TYPES } from "./types"
import useJwt from "@src/auth/jwt/useJwt"

const config = useJwt.jwtConfig

const initialState = {
  jobTempletes: [],
  specificJobTemplete: {},
  error: null,
  deleted: false,
  updated: false,
  added: false,
  loading: false,
  createdUpdatedLoading: false,
  res: null
}

const jobTempleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_REQUEST:
      return {
        ...state,
        updated: false,
        deleted: false,
        added: false,
        loading: true
      }
    case JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_SUCCESS:
      return {
        ...state,
        loading: false,
        jobTempletes: action.payload
      }
    case JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        specificJobTemplete: action.payload
      }
    case JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_REQUEST:
      return {
        ...state,
        added: false,
        createdUpdatedLoading: true,
        res: null
      }
    case JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_SUCCESS:
      return {
        ...state,
        added: true,
        createdUpdatedLoading: false,
        res: 1
      }
    case JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_FAIL:
      return {
        ...state,
        error: action.payload,
        createdUpdatedLoading: false,
        res:2
      }
    case JOB_TEMPLETE_TYPES.RESET_CREATE_TEMPLATE:
      return {
        ...state,
        error: null,
        deleted: false,
        updated: false,
        added: false,
        loading: false,
        createdUpdatedLoading: false,
        res: null
      }


    case JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_REQUEST:
      return {
        ...state,
        createdUpdatedLoading: true,
        updated: false,
        res: null
      }
    case JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_SUCCESS:
      return {
        ...state,
        updated: true,
        createdUpdatedLoading: false,
        res: 1
      }
    case JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_FAIL:
      return {
        ...state,
        error: action.payload,
        createdUpdatedLoading: false,
        updated: false,
        res: 2
      }
    case JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_REQUEST:
      return {
        ...state,
        deleted: false
      }
    case JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_SUCCESS:
      if (localStorage.getItem(config.currentPlan) !== "advance") {
        localStorage.setItem(
          "currCreateJobTempleteSetLimit",
          action.payload?.current
            ? action.payload?.current
            : localStorage.getItem("currCreateJobTempleteSetLimit") <
              localStorage.getItem("createJobTempleteSetLimit")
            ? localStorage.getItem("currCreateJobTempleteSetLimit") + 1
            : 0
        )
      }

      return {
        ...state,
        deleted: true
      }
    case JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_FAIL:
      return {
        ...state,
        error: action.payload,
        deleted: false
      }
    default:
      return state
  }
}

export default jobTempleteReducer
